export const formatDate = (date: string | Date, format?: string): string => {
  const dateObj = new Date(date);

  if (format === 'MMMM d, yyyy') {
    return dateObj.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  return dateObj.toLocaleDateString();
};

export const getPaymentMethodDisplayName = (type?: string): string | null => {
  if (!type) {
    return null;
  }
  switch (type) {
    case 'stripe':
    case 'StripeCardPayment':
      return 'Card';
    case 'stripeGooglePay':
      return 'Google Pay';
    case 'stripeApplePay':
      return 'Apple Pay';
    case 'CryptoPayment':
      return 'Crypto';
    case 'OfflinePayment':
      return 'Offline';
    default:
      return type;
  }
};
